module.exports = __webpack_public_path__ + "static/media/6.5c3c9674.jpg";